export default __webpack_public_path__ + "static/media/13117-godmosword.542893cf.pdf";